import {styled, Typography} from '@mui/material';

const StyledTitle = styled(Typography)`
	font-size: 16px;
	font-weight: 600;
`;

export {StyledTitle};
